<div class="confirm-card">
  <div class="confirm-card__header">
    <span class="confirm-card__title">{{ 'reportConfirmCard.title' | translate }}</span>
    <span class="confirm-card__badge">{{ reportType() }}</span>
  </div>

  <p class="confirm-card__hint">{{ 'reportConfirmCard.hint' | translate }}</p>

  <div class="confirm-card__body">
    @for (def of fieldDefs(); track def.key) {
      <!-- 可编辑字段（语音采集）始终显示，空值也显示供填写；只读预填字段仅在已有值时显示 -->
      @if (def.editable === false ? hasValue(def.key) : true) {
        <div class="confirm-card__field">
          <div class="confirm-card__label-row">
            <label class="confirm-card__label">{{ fieldLabel(def.key, def.label) }}</label>
            @if (isTimeAutoComplected(def.key)) {
              <span class="confirm-card__time-warn">{{ 'reportConfirmCard.timeWarn' | translate }}</span>
            }
          </div>
          @if (def.boolean) {
            <!-- 布尔字段（如"是否带挂"）：渲染为 是/否 选项，而非文本输入 -->
            <div class="confirm-card__bool">
              <button
                type="button"
                class="confirm-card__bool-btn"
                [class.confirm-card__bool-btn--active]="fields()[def.key] === true"
                [disabled]="def.editable === false"
                (click)="setValue(def.key, true)"
              >{{ 'reportConfirmCard.yes' | translate }}</button>
              <button
                type="button"
                class="confirm-card__bool-btn"
                [class.confirm-card__bool-btn--active]="fields()[def.key] === false"
                [disabled]="def.editable === false"
                (click)="setValue(def.key, false)"
              >{{ 'reportConfirmCard.no' | translate }}</button>
            </div>
          } @else if (def.textarea) {
            <textarea
              class="confirm-card__input confirm-card__input--textarea"
              [ngModel]="fields()[def.key]"
              (ngModelChange)="setValue(def.key, $event)"
              rows="2"
            ></textarea>
          } @else {
            <input
              class="confirm-card__input"
              [ngModel]="fields()[def.key]"
              (ngModelChange)="setValue(def.key, $event)"
              [readonly]="def.editable === false"
            />
          }
        </div>
      }
    }
  </div>

  @if (!submitted()) {
    <div class="confirm-card__attachment">
      <div class="confirm-card__attachment-label-row">
        <label class="confirm-card__attachment-label">{{ 'reportConfirmCard.attachmentLabel' | translate }}</label>
        <button
          type="button"
          class="confirm-card__attachment-add"
          (click)="fileInput.click()"
        >{{ 'reportConfirmCard.addImage' | translate }}</button>
        <input
          #fileInput
          type="file"
          accept="image/*"
          multiple
          hidden
          (change)="onFilesSelected($event)"
        />
      </div>

      @if (attachments.length) {
        <div class="confirm-card__previews">
          @for (att of attachments; track att.url; let i = $index) {
            <div class="confirm-card__preview">
              <img [src]="att.url" [alt]="att.name" class="confirm-card__preview-img" />
              <button
                type="button"
                class="confirm-card__preview-remove"
                (click)="removeAttachment(i)"
                title="{{ 'reportConfirmCard.remove' | translate }}"
              >×</button>
              <span class="confirm-card__preview-name" [title]="att.name">{{ att.name }}</span>
            </div>
          }
        </div>
      }
    </div>

    <div class="confirm-card__actions">
      <button class="confirm-card__btn confirm-card__btn--cancel" (click)="cancel.emit()">{{ 'reportConfirmCard.cancel' | translate }}</button>
      <button class="confirm-card__btn confirm-card__btn--confirm" (click)="submit()">{{ 'reportConfirmCard.confirmSubmit' | translate }}</button>
    </div>
  } @else {
    <div class="confirm-card__submitted">{{ 'reportConfirmCard.submitted' | translate }}</div>
  }
</div>
